@if(currentLocale()){
	<ogs-m3-icon icon="calendar"/>
	<time class="mat-font-body-sm">
			{{date() | date:'shortDate' : '' : currentLocale()!.value}}
			{{date() | date:'shortTime' : '' : currentLocale()!.value}}
	</time>
}
